import {Model} from './model';

export class Group implements Model {
  id: number;
  name: string;
  location_id: number;
  start_at: string;
  end_at: string;
  created_at: Date;
  updated_at: Date;
  employees_count: number;
  entities_count: number;
  capacity: number;
  type: string;
  meta: {
    employee_count: number,
    entities_count: number,
    female_entities_count: number,
    male_entities_count: number,
  };

  constructor(data?) {
    if (data != null) {
      this.fill(data);
    }
  }

  public fill(data) {
    this.id              = data['id'];
    this.location_id     = data['location_id'];
    this.name            = data['name'];
    this.start_at        = data['start_at'];
    this.end_at          = data['end_at'];
    this.created_at      = data['created_at'];
    this.updated_at      = data['updated_at'];
    this.employees_count = data['meta']['employee_count'];
    this.entities_count  = data['meta']['entities_count'];
    this.capacity        = data['capacity'] || 0;
    this.type            = data['type'];
    this.meta            = data['meta'];
  }

  public serialize() {
    return this;
  }

}
